import React, { useMemo } from 'react';
import Dialog from '../../components/Dialog';
import Controller from '../../mixins/Controller';
import ActionIcon from '../../components/ActionIcon';
import Grid from '../../components/Grid';
import DropZone from '../../components/DropZone';
import Button from '../../components/Button';
import notifications from '../../services/Notification';
import store from 'store';
import DateTimeFormatter from '../../lib/DateTimeFormatter';
import co from '../../lib/Co';
import ajax from '../../services/Ajax';

const ManualChartsTable = (props) => {
  const loginDetail = store.get('InteServLoginInfo');
  const { userId } = loginDetail
  const controller = props.controller;
  const data = controller.state.nonAPTCharts;
  const link = controller.state.filelink;
  const EditableColumns = useMemo(() => [
    {
      Header: '',
      accessor: 'action',
      Cell: (cellInfo) => {
        return cellInfo.row.original.addedby === userId ? <ActionIcon icon='fa-trash' className='remove-handle' action={() => { controller.deleteChart(cellInfo.row.original.id) }} /> : <></>
      }
    },
    {
      Header: 'Chart Name',
      accessor: 'name',
      Cell: (cellInfo) => {
        return <div><a href={`${link}/${cellInfo.row.original.id}`} onClick={(evt) => { controller.downloadFile(evt,`${link}/${cellInfo.row.original.id}`,`${cellInfo.cell.value}`); }} target="#">{cellInfo.cell.value}</a></div>
      }
    },
    {
      Header: 'Uploaded By',
      accessor: 'desc',
      Cell: (cellInfo) => {
        return <div>{cellInfo.cell.value}</div>

      }
    },
    {
      Header: 'Uploaded Date',
      accessor: 'dateadded',
      Cell: (cellInfo) => {
        return <div>{DateTimeFormatter.formatDate(cellInfo.cell.value)}</div>
          
      }
    }, 
  ], [])

  return (<div style={{ width: "100%" }}>

    <Grid id='results-table' columns={EditableColumns} data={data} canAddNewRow={false} showPagination={true} noDataText='No Manual Charts Added' />

  </div>);
}
class ManualChartUpload extends React.Component {

  constructor(props, context) {
    super(props, context);

    Object.assign(this, Controller);
  }

  componentDidMount = () => {
    this.initializeMixin();
  }

  handleClose = () => {
    const parentcontroller = this.props.parentcontroller;
    parentcontroller.updateAssets();
    return true;
  }
   downloadFile = (evt,fileLink,filename) => {
        evt.preventDefault();
        co(this, function* () {
            var results = yield ajax.get(fileLink); 
            const link = document.createElement("a");
            var extension=filename.split('.')[1];
            var attachmentType='';
            switch(extension)
            {
                case 'xlsx':
                    attachmentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    break;
                case 'xls':
                    attachmentType = 'application/vnd.ms-excel';
                    break;
                case 'pdf':
                    attachmentType = 'application/pdf';
                    break;
                case 'zip':
                    attachmentType = 'application/x-zip-compressed';
                    break;
                case 'png':
                    attachmentType = 'image/png';
                    break;
                case 'jpeg':
                    attachmentType = 'image/jpeg';
                    break;
                case 'jpg':
                    attachmentType = 'image/jpg';
                    break;
                case 'doc':
                    attachmentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    break;
                case 'docx':
                    attachmentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    break;
            }
            link.href ='data:'+attachmentType+';base64,' + results;
            link.setAttribute(
                'download',
                `${filename}`
            );
            document.body.appendChild(link);
            link.click();
            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
        .catch((error) => {
            console.error("Error fetching the file:", error);
          });;
    }
  render = () => {
    const width = 650;
    const height = 320;


    const controller = this.props.controller;
    const asset = this.props.controller.state.selectedAsset;
    const parentcontroller = this.props.parentcontroller;
    const handleUploadDiagram = (res) => {
      const selectedAsset = asset;
      const chartFilenames = controller.state.nonAPTCharts.map(x => x.name.toLowerCase());
      const assetNumber = selectedAsset.primarySerialNumber.toLowerCase();
      var fileName = res.file.name;
      const fileType = fileName.split('.')[1] || '';
      
      if (fileType.toLowerCase() != 'pdf') {
        parentcontroller.updateAssets();
        notifications.action('error').post({ msg: 'Invalid file type. .' + fileType + ' is an unrecognized file type to upload', title: 'File Type Error' });
        return;
      }
      if (!fileName.toLowerCase().includes(assetNumber)) {
        controller.getChartsList(selectedAsset);
        notifications.action('error').post({ msg: 'Invalid file name.', title: 'File Name Error' });
        return;
      }    
      if (chartFilenames.length > 0 && chartFilenames.includes(fileName.toLowerCase())) {
        controller.getChartsList(selectedAsset);
        notifications.action('error').post({ msg: 'File with same name already exists for selected asset', title: 'File Exists Error' });
        return;
      }
      const filenamewithoutasset = fileName.toLowerCase().replace(assetNumber.toLowerCase(),'');      
      const juliandate = filenamewithoutasset.split('_')[1] || '';
      if(!filenamewithoutasset.trim().startsWith('_'))
      {
        controller.getChartsList(selectedAsset);
        notifications.action('error').post({ msg: 'Invalid file name, primary serial number within file name is invalid', title: 'File Name Error' });
        return;
      }
      if(!juliandate.trim())
      {
        controller.getChartsList(selectedAsset);
        notifications.action('error').post({ msg: 'File contains invalid julian date', title: 'File Name Error' });
        return;
      }
      const alljuliandates = chartFilenames.map(x=> x.toLowerCase().replace(assetNumber.toLowerCase(),'')).map(y=>y.split('_')[1]);
      if (alljuliandates.filter(x => x.toLowerCase().includes(juliandate.toLowerCase())).length > 0) {
        controller.getChartsList(selectedAsset);
        notifications.action('error').post({ msg: 'File with same julian date already exists for selected asset', title: 'File Exists Error' });
        return;
      }
      controller.saveNonAPTCharts(res, selectedAsset);
      parentcontroller.updateAssets();
    }
    return (
      <Dialog {...this.props} header={this.props.header + ' for ' + asset.primarySerialNumber} width={width + 100} height={height + 305} id='asset-chart-dlg' onClose={this.handleClose}>
        <Dialog.Body>
          <ManualChartsTable controller={controller} />
        </Dialog.Body>
        <Dialog.Buttons>
          <>
            <DropZone onDrop={handleUploadDiagram} accept={".pdf"} multiple={false} width={0} height={0} style={{ borderStyle: 'none', padding: 'unset', display: "inline" }}>
              <Button icon='fa-file-upload' variant='success' size='sm' className='m-1' onClick={() => { }}>Upload Chart (Non APT)</Button>
            </DropZone>
          </>
          <Dialog.Button variant='danger' size='sm' className='btn' icon='fa-times' result={{ Cancel: true }}>Close</Dialog.Button>
        </Dialog.Buttons>
      </Dialog>
    );
  }
}

export default ManualChartUpload;
